<template>
    <div v-if="products.length > 0" class="featured__cars mb-18 md:mb-27">
        <h2 class="mb-8 text-center tx-30" style="text-transform: uppercase;">
            Añadidos recientemente
        </h2>
        <div class="wrapper-swiper-out swiper-cars">
            <div class="swiper-cars swiper-container grid">
                <swiper class="swiper-wrapper" :options="swiperOptionTop" ref="swiperTop">
                    <swiper-slide v-for="(product, key) in products" :key="key">
                        <thumbnail-car-component v-if="product" :product="product"></thumbnail-car-component>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="swiper-button-prev swiper-button-prev-featured" slot="button-prev">
               <span class="tx-30 tx-lightgrey-1"><i class="fas fa-chevron-left"></i></span>
            </div>
            <div class="swiper-button-next swiper-button-next-featured" slot="button-next">
               <span class="tx-30 tx-lightgrey-1"><i class="fas fa-chevron-right"></i></span>
            </div>
        </div>
    </div> 
</template>

<script>
import ThumbnailCarComponent from '../../layout/ThumbnailCarComponent';

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
    data() {
        return {
            products: [],
            swiperOptionTop: {
                slidesPerView: 'auto',
                freeMode: true,
                spaceBetween: 8,
                /* NAV */
                navigation: {
                    nextEl: '.swiper-button-next-featured',
                    prevEl: '.swiper-button-prev-featured'
                },
                breakpoints: {
                    540: {
                        slidesPerView: 1
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 16
                    },
                    1280: {
                        slidesPerView: 4,
                        spaceBetween: 29
                    }
                }
            },
            formData: null,
            err: {}
        }
    },

    components: {
        ThumbnailCarComponent,
        Swiper,
        SwiperSlide
    },

    created() {
        let vm = this;
        this.getFeaturedProductsAsync();
    },

    methods: {

        getLocation() {
            let vm = this;
        },

        async getFeaturedProductsAsync(position) {
            let vm = this;
            vm.resetForms();

            try {
                let {data} = await axios.get('/client/home/feature-products', { });
                vm.products = _.shuffle(data);
                vm.products = data
            } catch (error) { }
        },

        showErrors(error = null) {
            let vm = this;
            if ( error ) {
                vm.err = error.response.data;
            }
            vm.$swal({
                icon: 'error',
                title: 'Error',
                text: vm.err.message ? vm.err.message : 'Se encontraron algunos errores en el formulario',
            });
        },

        resetForms() {
            let vm = this;
            vm.formData = new FormData();
            vm.err = [];
        },
    },
}
</script>
